/**
 *
 *
 *
 *
 *
 *
 */
export function isPlainObject<T>(object: T | Element | Window): boolean {
  return (
    !!object &&
    Object.prototype.toString.call(object) === "[object Object]" &&
    !(object as Element).nodeType &&
    object !== (object as Window).window
  );
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function isEmptyObject<T extends Record<string, unknown>>(
  object: T,
  inherited?: boolean,
): boolean {
  const properties: unknown[] = [];

  if (!inherited) {
    return Object.keys(object).length === 0;
  }

  for (const prop in object) {
    properties.push(prop);
  }

  return Object.keys(properties).length === 0;
}
